"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PushingTooltip_1 = require("./PushingTooltip");
exports.default = PushingTooltip_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tooltip/PushingTooltip/index.js
// module id = 517
// module chunks = 8